export default "__VITE_ASSET__BtsEkyL7__"